import React, { Component } from 'react'

import '../App.css';
import './styles/Portfolio.css';

import PortfolioDesktop from './Desktop/Portfolio'
import PortfolioMobile from './Mobile/Portfolio'

import Modal from './PortfolioModal';

import firebase from '../firebase';

export default class Portfolio extends Component {

  state = {
    // FOR TESTING PURPOSES ONLY, REPLACE WITH REAL VALUES
    artists: [],
    selectedArtistKey: null,
    loading: false
  }

  componentDidMount () {

    this.setState({
      loading: true
    })

    const portfolioRef = firebase.database().ref('portfolio');

    portfolioRef.once('value').then((snapshot) => {
      let portfolioData = snapshot.val();

      let artists = portfolioData.artists;

      let artistResults = [];
      for (var i in artists) {

        let songs = [];
        if (artists[i].songs) {
          for (var k in artists[i].songs) {
            songs.push(artists[i].songs[k]);
          }
        }

        let spotifyLink = '';
        if (artists[i].spotify) {
          spotifyLink = artists[i].spotify;   
        }

        artistResults.push(
          {
            key: i,
            name: artists[i].name,
            songs: songs,
            picture: artists[i].picture,
            spotify: spotifyLink
          }
        );
      }

      this.setState({
        artists: artistResults,
        loading: false
      });

      /*this.setState({
        artists: []
      });*/
    });
  }

  selectArtist = (key, event) => {
    event.stopPropagation();
    this.setState({
      selectedArtistKey: key
    });

    this.props.moveAction();
  }

  clearSelectedArtist = () => {
    this.props.moveBackAction();

    this.setState({
      selectedArtistKey: null
    });
  }

  getSelectedArtist = () => {
    const selectedArtistKey = this.state.selectedArtistKey;
    let selectedArtist = null;
    this.state.artists.forEach(function (artist) {
      const { key } = artist;

      if (key == selectedArtistKey) {
        selectedArtist = artist;
        return;
      }
    });

    return selectedArtist;
  }

  render() {
    let selectedArtist = this.getSelectedArtist();

    let currentScreen = null;

    if (this.props.isMobile) {
      currentScreen = <PortfolioMobile closeAction={this.clearSelectedArtist}
                                          artists={this.state.artists}
                                          selectedArtistKey={this.state.selectedArtistKey}
                                          leftAction={this.props.leftAction}
                                          selectArtistAction={this.selectArtist}
                                          isLoading={this.state.loading} />;
    } else {
        currentScreen = <PortfolioDesktop closeAction={this.clearSelectedArtist}
                                          artists={this.state.artists}
                                          selectedArtistKey={this.state.selectedArtistKey}
                                          leftAction={this.props.leftAction}
                                          moveAction={this.props.moveAction}
                                          moveBackAction={this.props.moveBackAction}
                                          selectArtistAction={this.selectArtist}
                                          isLoading={this.state.loading}/>;
    }

    return (
      <div style={{ width: '100%', height: '100%' }}>

        <Modal closeAction={this.clearSelectedArtist}
                artist={selectedArtist} 
                isMobile={this.props.isMobile} />

        {currentScreen}

      </div>
    );
  }
}
